<template>
  <div
    v-if="isVisible"
    class="overlay"
    @click="closePopup"
  >
    <div class="popup">
      <div class="message">
        <slot />
      </div>
      <div class="close-button-container">
        <button
          class="close-button"
          @click="closePopup"
        >
          {{ $t("HighLight-ButtonText") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {useI18n} from "vue-i18n";

export default defineComponent({
  name: "HighlightPopup",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close-popup"],
  setup() {
    const {t} = useI18n();
    return {t};
  },
  methods: {
    closePopup() {
      this.$emit("close-popup");
    },
  },
});
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.popup {
  width: 100%;
  background: white;
  border-radius: 10px 10px 0 0;
  animation: slideUp 0.3s ease-out;
  position: relative;
}

.close-button-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--Gray-elements-Background-BLOCKS);
  padding-bottom: 50px;
  padding-left: 0;
  padding-right: 0;
}

.close-button {
  min-width: 95%;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--Primary-Green-1);
  background: var(--Primary-Green-1);
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  color: #fff;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-style: normal;
}

.message {
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@media (max-width: 350px) {
  .close-button {
    min-width: 85%;
  }
}

</style>
